var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 12C14.3 12 17 9.3 17 6 17 2.7 14.3 0 11 0 7.7 0 5 2.7 5 6 5 9.3 7.7 12 11 12ZM15.2 13.5H14.4C13.4 14 12.2 14.3 11 14.3 9.8 14.3 8.6 14 7.6 13.5H6.8C3.3 13.5 0.5 16.3 0.5 19.8V21.8C0.5 23 1.5 24 2.8 24H19.3C20.5 24 21.5 23 21.5 21.8V19.8C21.5 16.3 18.7 13.5 15.2 13.5Z"}));
}

User.defaultProps = {"viewBox":"0 0 22 24"};

module.exports = User;

User.default = User;
